import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  type CategoriesQueryResult,
  useCategoryMetrics,
} from '@/api/generated';
import { BarChart } from '@/components/blocks/charts/bar-chart';
import { BarChartSkeleton } from '@/components/blocks/charts/bar-chart-skeleton';

interface CategoryProps {
  category: CategoriesQueryResult[number];
}

const Category = ({ category }: CategoryProps) => {
  const { data: metrics, isLoading } = useCategoryMetrics(category.id);
  const { t } = useTranslation();
  if (isLoading) {
    return <BarChartSkeleton className='max-w-[800px]' />;
  }
  if (!metrics) {
    return <span>{t('dataAgent.metrics.noMetrics')}</span>;
  }
  return (
    <BarChart
      className='max-w-[800px]'
      title={category.name}
      xAxis='name'
      yAxis='metric'
      data={metrics}
      chartConfig={{
        name: {
          label: t('dataAgent.name'),
          color: 'var(--chart-1)',
        },
        metric: {
          label: t('dataAgent.count'),
          color: 'var(--chart-2)',
        },
      }}
    />
  );
};

export default Category;
